const faqs = [
  {
    question: "What is Bonsai-Broker?",
    answer: "Bonsai-Broker is an online marketplace for bonsai artists and enthusiasts to purchase and sell bonsai trees, pots, tools, supplies, ETC.",
  },
  {
    question: "Who is Bonsai-Broker?",
    answer: "Bonsai-Broker is a locally rooted, independently owned small business dedicated to serving its customers without the influence or ownership of a large corporation.",
  },
  {
    question: "When was Bonsai-Broker founded?",
    answer: "Bonsai-Broker was founded in 2026 by a man from Pennsylvania with a deep love for bonsai. When he realized there wasn't a great online marketplace for bonsai and bonsai accessories, he decided to make his own to help the bonsai community.",
  },
  {
    question: "How does Payment work?",
    answer: "All online payments go through Stripe. Sellers complete one Stripe Connect onboarding flow for required seller information and payouts; Bonsai-Broker does not require a separate ID-verification step. If you are making a local purchase, it is up to you and the seller which form of payment works for both of you. You can still use Stripe through our platform, or you can use cash, Venmo, PayPal, ETC. Please note, anytime using Stripe through Bonsai-Broker, buyers pay a 5% Broker Fee on the item subtotal.",
  },
  {
    question: "Why do we charge a 5% Broker Fee?",
    answer: "This is to fund the website itself. Unfortunately, the services used to host this website are not free. There are several recurring monthly costs we must cover.",
  },
];

export default function FaqPage() {
  return (
    <main data-testid="faq-page" className="min-h-[calc(100vh-74px)] bg-[#26352B] px-4 py-10 text-[#F7F2EA] md:px-8 md:py-16">
      <section className="mx-auto max-w-5xl">
        <p data-testid="faq-kicker" className="text-xs uppercase tracking-[0.22em] text-[#D86F55]">Bonsai-Broker</p>
        <h1 data-testid="faq-heading" className="mt-3 text-5xl font-light leading-none md:text-6xl">Frequently Asked Questions</h1>
        <div data-testid="faq-list" className="mt-10 grid gap-5">
          {faqs.map((faq, index) => (
            <article data-testid={`faq-item-${index}`} key={faq.question} className="border border-[#8E3F31] bg-[#1F2E25] p-6">
              <h2 data-testid={`faq-question-${index}`} className="text-3xl font-light text-[#F7F2EA]">{faq.question}</h2>
              <p data-testid={`faq-answer-${index}`} className="mt-4 max-w-4xl text-base leading-8 text-[#E8E4D9]">{faq.answer}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}